module.exports = __webpack_public_path__ + "static/media/ic-user.877a015e.svg";